<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="收款名称">
              <el-input clearable v-model.trim="where.paymentName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="付款名称">
              <el-input clearable v-model.trim="where.payerName" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.type" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="24">
            <el-form-item label="选择时间">
              <div class="recon-time-wrap">
                <el-radio-group v-model="timeQuick" size="small" @change="onTimeQuickChange">
                  <el-radio-button label="today">今日</el-radio-button>
                  <el-radio-button label="yesterday">昨日</el-radio-button>
                  <el-radio-button label="week">本周</el-radio-button>
                  <el-radio-button label="month">本月</el-radio-button>
                  <el-radio-button label="lastMonth">上月</el-radio-button>
                  <el-radio-button label="days30">30日</el-radio-button>
                </el-radio-group>
                <el-date-picker
                  v-model="where.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="onTimePickerChange" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" @click="onExportClick">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="recon-stat-bar">
        <span>流水笔数: {{ summary.total_count }}</span>
        <span>入账金额: {{ summary.in_amount }}</span>
        <span>出账金额: {{ summary.out_amount }}</span>
        <span>净变动: {{ summary.net_amount }}</span>
      </div>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 360px)">
        <template slot="toolbar">
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData">
            初始化
          </el-button>
        </template>
      </ele-pro-table>
    </el-card>

    <export-progress-dialog ref="exportDialog" biz="bankrecords" title="导出银行卡帐变" />
  </div>
</template>

<script>
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';
import { getDictData } from '@/utils/dict';
import reconTime from '@/mixins/recon-time';

const EMPTY_SUMMARY = {
  total_count: 0,
  in_amount: '0.00',
  out_amount: '0.00',
  net_amount: '0.00'
};

export default {
  name: 'BankRecords',
  components: { ExportProgressDialog },
  mixins: [reconTime],
  data() {
    return {
      url: '/BankRecords/index',
      columns: [
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'paymentName', label: '收款名称', fixed: 'left', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'payerName', label: '付款名称', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'order_no', label: '系统订单', showOverflowTooltip: true, minWidth: 150, align: 'center' },
        { prop: 'type', label: '交易类型', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'before_money', label: '变动前', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'money', label: '变动金额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'after_money', label: '实际余额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'remark', label: '交易内容', showOverflowTooltip: true, minWidth: 500, align: 'left' },
        {
          prop: 'create_time',
          label: '更新时间',
          showOverflowTooltip: true,
          minWidth: 170,
          align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        }
      ],
      where: {
        paymentName: '',
        payerName: '',
        type: undefined,
        time: null
      },
      typeOptions: [],
      summary: { ...EMPTY_SUMMARY }
    };
  },
  mounted() {
    this.loadTypeOptions();
    this.loadStats();
  },
  methods: {
    reload() {
      this.$refs.table && this.$refs.table.reload({ where: this.where });
      this.loadStats();
    },
    reset() {
      this.where = { paymentName: '', payerName: '', type: undefined, time: null };
      this.applyTimeQuick('today', true);
    },
    loadStats() {
      this.$http
        .post('/BankRecords/getCount', this.where)
        .then((res) => {
          if (res.data.code === 0) {
            this.summary = { ...EMPTY_SUMMARY, ...(res.data.data || {}) };
            return;
          }
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(res.data.msg);
        })
        .catch((e) => {
          this.summary = { ...EMPTY_SUMMARY };
          this.$message.error(e.message);
        });
    },
    onExportClick() {
      this.$refs.exportDialog.start({ ...this.where });
    },
    loadTypeOptions() {
      getDictData('bank_record_type')
        .then((list) => {
          this.typeOptions = (list || []).map((item) => ({
            value: item.dictDataCode,
            label: item.dictDataName
          }));
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    initData() {
      this.$confirm('初始化将清空全部收款流水且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/BankRecords/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped src="@/styles/recon-stat.css"></style>
